import CustomModal from "components/lib/customModal";
import { useDemo } from "contexts/DemoContext";
import CONSTANTS from "core/constants";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { AttachmentViewer } from "./attachmentViewer";
import { GridContainer } from "./messageModal.styles";
import { ViewMessageModalProps } from "./messageModal.types";
import { TextField } from "@mindlercare/ui-web";

export const ViewMessageModal = ({
  message,
  onClose,
  patientName,
}: PropsWithChildren<ViewMessageModalProps>) => {
  const { t } = useTranslation();
  const isSensitiveDataHidden = useDemo();
  return (
    <CustomModal.Wrapper
      size="large"
      onClose={() => onClose(null)}
      titleText={t("PSYCHOLOGIST_MESSAGE_MODAL_TITLE", {
        patient: message?.date,
      })}
      open={!!message}
    >
      <GridContainer>
        <TextField
          disabled
          width="full"
          label={t("PATIENT_MESSAGE_MODAL_TITLE")}
          value={message?.title || t("PSYCHOLOGIST_MESSAGE_MODAL_PLACEHOLDER")}
          onChange={() => null}
          sx={{ width: "100%" }}
          hideSensitiveData={isSensitiveDataHidden}
        />
        <TextField
          multiline
          disabled
          width="full"
          label={t("PATIENT_MESSAGE_MODAL_TITLE_MESSAGE")}
          value={
            isSensitiveDataHidden
              ? (message?.body?.replace(patientName, CONSTANTS.DEMO) ?? "")
              : (message?.body ?? "")
          }
          onChange={() => null}
          sx={{ width: "100%" }}
          testId="messageModalBody"
          hideSensitiveData={isSensitiveDataHidden}
        />
        {message?.attachmentKeys && message.attachmentKeys.length > 0 && (
          <AttachmentViewer attachmentKeys={message?.attachmentKeys} />
        )}
      </GridContainer>
    </CustomModal.Wrapper>
  );
};
